export default __webpack_public_path__ + "static/media/backgroundNotAllowLocationMB.c8f6e525.png";